// Generated by genversion.
export const version = '2.140.0';
